import { createFileRoute } from '@tanstack/react-router';

import { ChatPage } from '../ChatPage';

export const Route = createFileRoute('/_protected/_consumer/chat/$conversationId/')({
  component: ChatPage,
});
